import Link from "next/link";
import React from "react";
import ChatPod from "@/app/components/aws/connect/ChatPod";

const navigation = {
    main: [
        { name: 'IT Solutions', href: '/itsolutions' },
        { name: 'Websites', href: '/frontend' },
        { name: 'Apps', href: '/apps' },
        { name: 'Back End', href: '/backend' },
        { name: 'DevSecOps', href: '/devopsdevsecops' },
        { name: 'Contact', href: '/contact' },
    ],
}

export default function Footer() {
    return (
        <footer className="bg-white relative">
            <div className="mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8">
                <nav aria-label="Footer" className="-mb-6 flex flex-wrap justify-center gap-x-12 gap-y-3 text-sm/6">
                    {navigation.main.map((item) => (
                        <Link key={item.name} href={item.href} className="text-gray-600 hover:text-gray-900">
                            {item.name}
                        </Link>
                    ))}
                </nav>
                <p className="mt-10 text-center text-sm/6 text-gray-600">&copy; 2025 FullStack Software Labs. All rights
                    reserved.</p>
            </div>

            {/* AWS Connect Chat Pod */}
            <ChatPod />


        </footer>
    )
}